import React from 'react'
import { StyledPromoCard, StyledPromoImg } from '../PromoCard.styled'

export const UpLatePromoCard = () => {
    const promo = require('../assets/up-late.webp')
    return (
        <StyledPromoCard promotion="up-late">
            <StyledPromoImg
                src={promo}
                alt="Up Late with Ben Harvey. Watch Now."
            />
        </StyledPromoCard>
    )
}
